<script>
  import { onDestroy, createEventDispatcher, tick } from 'svelte';

  import Text from '@components/Text.svelte';
  import Avatar from '@components/Avatar.svelte';
  import Track from '@utils/track';
  import { getCurrentUserStore } from '@stores/current_user';

  import ComponentEvents from '@utils/component-events';
  import { getGroupStore } from '@stores/group';
  let recsStore = getGroupStore('recsStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let groupStore = getGroupStore('groupStore');
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import CreatorSpotlightModal from '@app-components/modal/CreatorSpotlightModal.svelte';
  import RecAjax from '@ajax/rec';
  import { goto } from '$app/navigation';
  import CookieHelper from '@utils/cookie-helper';

  const dispatch = createEventDispatcher();

  export let id;
  export let customGroupStore;

  let rec = recsStore.find(id);
  let recObject = recObjectsStore.find(rec.rec_object_id);
  let group = customGroupStore || groupStore;
  let currentUser = getCurrentUserStore('default');
  let showCreatorSpotlightModal = false;

  $: {
    rec = recsStore.find(id);
    recObject = recObjectsStore.find(rec.rec_object_id);
  }

  export let mobile = false;
  export let lines = 1;
  export let i;
  export let showAvatar = true;
  export let showUpDownArrow = mobile == false;
  export let avatarSizePx = 0;
  export let style = '';
  export let viewStyle = 'column';
  export let showNames = true;
  export let nameDescriptionStyle = '';
  export let avatarStyle = '';
  export let descriptionStyle = '';
  export let arrowStyle = '';
  export let nameStyle = '';
  export let editable = rec.permissions.edit;
  export let view = '';
  export let shaved;
  export let shavedOnFirstLoad;
  export let expandable = true;

  let unsubRec = rec.subscribe((x) => (rec = x));
  let toggleExpandContent;
  let withDescription = editable || rec.user_note;
  let toggleArrowEnabled = true;
  let copyPaste = false;

  let updateNote = async function (e) {
    let data = { user_note: e.detail.text, copy_paste: copyPaste };
    await RecAjax.update(group, rec, data);
    rec.set({ ...rec, ...data });
    dispatch('blur');
  };

  let trackAndDispatchEvents = async function () {
    if (!expandable) {
      return;
    }

    await tick();
    if (shavedOnFirstLoad) {
      if (shaved) {
        dispatch('collapsed');
      } else {
        Track.recExpanded({ group, rec, recObject, user: currentUser });
        dispatch('expanded');
      }
    } else {
      dispatch('click');
    }
  };

  let toggleExpandAndTrack = function () {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }

    ComponentEvents.trigger('close-all-reviews', rec.id);
    toggleExpandContent();
    trackAndDispatchEvents();
  };

  let redirectToUserProfile = async function (_e) {
    await Track.recNameClicked({ rec, group, user: currentUser });
    const author = rec.user;
    if (CookieHelper.allowSpotlightModalFlow(author)) {
      CookieHelper.setSpotlightVisitsCookie(author);
      showCreatorSpotlightModal = true;
    } else {
      goto(rec.user.profile_path);
    }
  };

  let unsubCloseAllReviews = ComponentEvents.on('close-all-reviews', (id) => {
    if (!editable && shavedOnFirstLoad && !shaved && rec.id != id) {
      toggleExpandContent();
      dispatch('collapsed');
    }
  });

  onDestroy(() => {
    unsubRec();
    unsubCloseAllReviews();
  });
</script>

<style style="text/scss" lang="scss">
  .flex-start {
    align-items: flex-start !important;
  }

  .ui-note {
    margin-bottom: 0px;
    padding: 10px;
    transition: all 0.25s ease 0s;
    display: flex;
    align-items: center;
    position: relative;

    .ui-note-name-note {
      flex: 1;
      margin-left: 20px;
    }

    .ui-note-name {
      font-weight: 500;
      transition: all;
      padding-left: 5px;
      color: black;
      display: inline-block;

      &:hover {
        color: black;
      }
    }

    .ui-note-description {
      display: flex;
      font-size: 14px;
      white-space: pre-line;
      word-break: break-word;
      line-height: 24px;
      overflow: hidden;
      margin-top: 5px;
      max-width: 100%;
      color: #5e518e;
    }
  }

  .up-arrow {
    transform: rotate(-180deg);
  }

  .mobile {
    padding: 0px !important;
    // min-height: 38px !important;

    .ui-note-name-note {
      margin-left: 15px;
    }

    .ui-note-description {
      margin-top: 2px !important;
    }

    .updownarrow {
      margin-top: 9px !important;
    }

    .ui-avatar {
      // margin-top: 4px;
    }

    .only-name-no-description {
      height: 40px;
      align-items: center;
      display: flex;
    }
  }

  .grid {
    .ui-note-description {
      margin-top: 3px !important;
    }

    .updownarrow {
      margin-top: 12px !important;
    }
  }

  .space-between {
    margin-top: 20px;
  }

  .detail-view {
    min-height: 40px;

    .review-avatar {
      position: absolute;
    }

    .ui-note-name-note {
      padding-top: 7px;
      min-height: 40px;
    }

    .ui-note-name {
      padding-left: 42px;
    }

    .ui-note-description {
      margin-left: -10px;
      margin-top: 20px;
    }
  }

  .detail-view.mobile {
    .updownarrow {
      margin-top: 105px !important;
    }
  }

  .updownarrow-placeholder {
    margin-top: 14px;
    padding: 10px;
    margin-bottom: -10px;
    padding-right: -10px;
    width: 29px;
    height: 5px;
    margin-right: -8px;
  }

  .grid.mobile {
    margin-top: 7px !important;

    .updownarrow {
      margin: 0px !important;
      padding: 0px !important;
      padding-right: 12px !important;
      margin-top: 20px !important;
      padding-top: 4px !important;
      padding-left: 12px !important;
    }

    .updownarrow-placeholder {
      margin-top: 0px !important;
    }

    .review-avatar {
      margin-top: 7px;
    }

    .ui-note-description {
      line-height: 20px;
      min-height: 44px !important;
      display: flex !important;
      align-items: center !important;
    }

    .ui-note-name-note {
      margin-left: 8px;
      margin-right: 10px;
    }
  }

  .ignore-clicks {
    pointer-events: none;
  }
</style>

{#if showCreatorSpotlightModal}
  <CreatorSpotlightModal
    mobile={mobile}
    user={rec.user}
    bind:showModal={showCreatorSpotlightModal}
    on:close={() => {
      showCreatorSpotlightModal = false;
    }} />
{/if}

<div
  style={style}
  data-rec-id={rec.id}
  data-user-id={rec.user.id}
  class="ui-note {viewStyle}"
  class:space-between={mobile && i > 0}
  class:mobile={mobile}
  class:detail-view={view == 'detail-view'}
  class:flex-start={editable || rec.user_note}
  class:ignore-clicks={!expandable && !editable}>
  {#if mobile}
    <div
      style="position: absolute; margin-top: -160px; visibility: none; opacity:
      0; z-index: -1"
      id="ui-rec-{rec.id}" />
  {:else}
    <div
      style="position: absolute; margin-top: -70px; visibility: none; opacity:
      0; z-index: -1"
      id="ui-rec-{rec.id}" />
  {/if}

  {#if showAvatar}
    <div class:ui-avatar={mobile} class="review-avatar" style={'flex-basis: 40px; flex-shrink: 0; ' + avatarStyle}>
      <Avatar
        on:click={redirectToUserProfile}
        href={rec.user.profile_path}
        src={rec.user.avatar_url}
        width={avatarSizePx || (mobile ? 35 : 40)}
        user={rec.user}
        mobile={mobile} />
    </div>
  {/if}
  <div
    style="{showAvatar == false ? 'margin-left: 0px;' : ''}
    {nameDescriptionStyle}"
    class="ui-note-name-note"
    class:only-name-no-description={!withDescription}>
    {#if showNames}
      <AccountVerifiedIcon
        dimension={12}
        verified={rec.user.verified}
        clickable={true}
        extraStyleIcon={nameStyle}
        on:areaClicked={() => redirectToUserProfile()}>
        <svelte:fragment slot="account-name">
          <a
            style={nameStyle}
            href={rec.user.profile_path}
            on:click|preventDefault={redirectToUserProfile}
            class="ui-note-name undraggable">
            {rec.user.name}
            {#if rec.user.education}
              <span
                style="color: #6c757d; margin-left: 10px; font-weight: normal;
          font-size: 13px">
                {[rec.user.education.degree, rec.user.education.class_year]
                  .filter((x) => x != null && x != '')
                  .join(' - ')}
              </span>
            {/if}
          </a>
        </svelte:fragment>
      </AccountVerifiedIcon>
    {/if}
    {#if withDescription}
      <div class="ui-note-description undraggable" on:click|stopPropagation={() => {}} style={descriptionStyle}>
        <Text
          editor={!mobile}
          editable={editable}
          text={rec.user_note}
          lines={lines}
          style="width: 100%; padding: 0px; padding-left: 4px !important; margin: 0px;"
          expand={expandable}
          placeholder={'Add note'}
          bind:shaved={shaved}
          bind:shavedOnFirstLoad={shavedOnFirstLoad}
          bind:toggleExpandContent={toggleExpandContent}
          on:blur={(e) => {
            updateNote(e);
            toggleArrowEnabled = false;
            setTimeout(() => (toggleArrowEnabled = true), 500);
          }}
          on:file-upload-complete={(e) => {
            updateNote(e);
          }}
          on:focus={() => {
            dispatch('focus');
          }}
          on:click={() => {
            trackAndDispatchEvents();
          }}
          on:paste={() => (copyPaste = true)}
          linkClicked={(url) => {
            Track.recLinkClicked({
              group,
              rec,
              url,
              user: currentUser,
            });
          }} />
      </div>
    {/if}
  </div>
  {#if showUpDownArrow}
    {#if shavedOnFirstLoad && expandable}
      <div
        class="updownarrow undraggable"
        style="user-select: none; margin-top: 14px; padding: 10px; margin-bottom: -10px;
        padding-right: -10px; cursor: pointer; margin-right: -8px; {arrowStyle}"
        on:click|preventDefault|stopPropagation={() => {
          if (toggleArrowEnabled) {
            toggleExpandAndTrack();
          }
        }}>
        <svg
          class:up-arrow={!shaved}
          width="9"
          height="5"
          class="adjustable-element"
          viewBox="0 0 9 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75924 0.349209C8.39982 -0.0701172 7.76852 -0.118679 7.34919
            0.240744L4.49998 2.68292L1.65077 0.240744C1.23145 -0.118679 0.600147
            -0.0701173 0.240725 0.349209C-0.118698 0.768535 -0.0701356 1.39983
            0.34919 1.75926L3.84919 4.75926C4.22368 5.08025 4.77628 5.08025
            5.15077 4.75926L8.65077 1.75926C9.0701 1.39983 9.11866 0.768535
            8.75924 0.349209Z"
            fill="#5E518E" />
        </svg>
      </div>
    {:else}
      <div class="updownarrow-placeholder" />
    {/if}
  {/if}
</div>
